import React from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box, Container, Typography, Avatar, Stack } from "@mui/material";
import { amerjeet, arun, brigdhar, mahesh, nandhini } from "../../assets";

const SlickSlider = Slider as unknown as React.FC<any>;

const testimonials = [
    {
        name: "Amarjeet Jat",
        role: "Assistant General Manager - Sales & Hospitality at Moonglade by E-infra and IRA venture",
        image: amerjeet,
        text: "In a world of generic sales tactics, Rajiv Williams is a master of his craft. His 'Luxury Sales Mastery' framework is a game-changer—it shifts the focus from 'chasing the lead' to 'commanding the room' with psychological precision and consultative grace. Since working with Rajiv, I’ve moved away from high-pressure closing and toward high-value leadership. The result? A massive boost in my conversion rates and a newfound level of professional confidence. For any founder or sales leader aiming for the top 1%, Rajiv is the ultimate catalyst for growth.",
    },
    {
        name: "Mahesh Valsa",
        role: "Driving Growth & Innovation | Key Account Expert in Banking, FinTech, & Digital TransformationDriving Growth & Innovation | Key Account Expert in Banking, FinTech, & Digital Transformation",
        image: mahesh,
        text: [
            "I have known Rajiv for several years and have always been impressed by his deep knowledge and strategic approach to sales and business development. He is a true entrepreneur and advisor, with a keen eye for identifying market opportunities and a talent for building successful sales frameworks. His insights are invaluable, and he consistently demonstrates a forward-thinking perspective. Rajiv is a go-to resource for anyone seeking expert advice and mentorship in the competitive world of sales and consulting."
        ]
    },
    {
        name: "Brigadier (Dr) Inder Sethi",
        role: "Director | Global Strategy Head | Strategy, Innovation & Leadership | 2xTEDx |Keynote Speaker | Author",
        image: brigdhar,
        text: [
            "It's a rare privilege to encounter a professional who not only understands a market but actively defines it. That professional is Rajiv Williams. I've had the pleasure of knowing Rajiv since 2022, and from the outset, his extraordinary clarity of vision and strategic foresight were undeniable.",
            "Rajiv hasn't just entered the uber-luxury sales space; he has masterfully carved a unique and indispensable niche. He possesses an innate ability to connect with clients on a profound level, translating their aspirations into a tangible reality. When you think of trust and integrity in luxury sales, you think of Rajiv. His dedication to his craft and his clients is second to none."
        ]
    },
    {
        name: "Nandini Reddy",
        role: "Partner at Axis Burgundy Private | Wealth Advisory & Relationship Management",
        image: nandhini,
        text: [
            "I had the pleasure of meeting Mr. Rajiv William recently and was instantly struck by his deep understanding of the luxury real estate space in Hyderabad. His network is not only vast but also incredibly well-cultivated — a true reflection of the trust and credibility he’s built over the years.",
            "What stood out to me most is his willingness to support and connect people meaningfully. Despite being a busy professional, he was kind enough to make space for a thoughtful conversation and generously opened a few key doors in his circle for me."
        ]
    },
    {
        name: "Arun K Gattu",
        role: "Vice President - Sales & Marketing Specializing in S&M strategy Expert in market trends & micro-market analysis",
        image: arun,
        text: [
            "I’ve known Rajiv for a long time, and when it comes to real estate, he’s the guy you want in your corner. Need market insights? He’s got them. Looking for the best deals? He knows where to find them. Have a real estate query at midnight? Don’t be surprised if he replies in seconds!",
            "What makes Rajiv stand out is not just his deep industry knowledge but also his cool, no-stress approach. He simplifies things, gives honest advice, and always delivers with speed and clarity. If real estate is on your mind, Rajiv is the one to call!"
        ]
    },
];

const Testimonials = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
            { breakpoint: 900, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <Box sx={{ position: "relative", py: 8, color: "#000" }}>
            {/* BG IMAGE */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/luxury_durgam_bridge.webp")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    zIndex: -2,
                }}
            />

             <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      background: `
                        linear-gradient(
                          135deg,
                          rgba(15,99,165,0.85),
                          rgba(15,99,165,0.6)
                        )
                      `,
                      zIndex: -1,
                    }}
                  />
                   {/* ✨ GLOSS LIGHT */}
                  {/* <Box
                    sx={{
                      position: "absolute",
                      top: "-20%",
                      left: "-10%",
                      width: "600px",
                      height: "600px",
                      background:
                        "radial-gradient(circle, rgba(255,255,255,0.25), transparent 70%)",
                      filter: "blur(80px)",
                    }}
                  /> */}
            <Container maxWidth="lg">

                {/* Heading */}
                <Box textAlign="center" mb={8}>
                    <Typography
                        variant="h3"
                        sx={{

                            fontWeight: 600,
                            color: "#fff",
                        }}
                    >
                        Testimonials
                    </Typography>

                    {/* <Typography sx={{ mt: 2, color: "#fff" }}>
                        Real results from real people
                    </Typography> */}
                </Box>

                <Box
                    sx={{
                        ".slick-list": {
                            mx: "-12px", // negative margin
                        },
                        ".slick-slide > div": {
                            px: "12px", // gap between slides
                        },
                    }}
                >

                    {/* Slider */}
                    <SlickSlider {...settings}>
                        {testimonials.map((t, i) => (
                            <Box key={i} sx={{ display: "flex", gap: 4 ,
                                
                            }}>

                                <Box
                                    sx={{
                                        flex: 1, // ✅ equal height
                                        display: "flex",
                                        
                                    }}
                                >
                                    <Box
                                        sx={{
                                            flex: 1, // ✅ equal height
                                            p: 4,
                                            borderRadius: "20px",
                                            position: "relative",
                                            overflow: "hidden",

                                            /* 🔥 TRUE GLASS */
                                            background: "rgba(255,255,255,0.06)",
                                            backdropFilter: "blur(10px)",
                                            WebkitBackdropFilter: "blur(18px)",

                                            /* BORDER + DEPTH */
                                            border: "1px solid rgba(255,255,255,0.3)",
                                            // boxShadow: `
                                            //     0 25px 40px -10px rgba(0,0,0,0.45),
                                            //     inset 0 1px 0 rgba(255,255,255,0.4)
                                            //     `,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            height:{xs:"auto",md:"380px"}
                                           
                                        }}
                                    >

                                        {/* TEXT */}
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: "#ffffff",
                                                fontSize: "0.95rem",
                                                lineHeight: 1.6,
                                                opacity: 0.95,
                                                textAlign: 'start'
                                            }}
                                        >
                                            {/* handle array or string */}
                                            {Array.isArray(t.text)
                                                ? t.text.map((para, idx) => (
                                                    <span key={idx}>
                                                        {para}
                                                        <br /><br />
                                                    </span>
                                                ))
                                                : `“${t.text}”`}
                                        </Typography>

                                        {/* USER SECTION (BOTTOM FIXED) */}
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            alignItems="center"
                                            sx={{
                                                mt: "auto", // 🔥 PUSH TO BOTTOM
                                                pt: 3,
                                            }}
                                        >
                                            <Avatar src={t.image} />

                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "#ffffff",
                                                        fontWeight: 600,
                                                        fontSize: "18px",
                                                        textAlign: "start",
                                                    }}
                                                >
                                                    {t.name}
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "rgba(255,255,255,0.8)",
                                                        textAlign: "start",
                                                        fontSize:{xs:"auto",md:"13px"}
                                                    }}
                                                >
                                                    {t.role}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                    </Box>
                                </Box>

                            </Box>
                        ))}
                    </SlickSlider>
                </Box>

            </Container>
        </Box>
    );
};

export default Testimonials;